<template>
    <b-container>
        <b-modal
            v-model="openModal"
            size="lg"
            header-bg-variant="dark"
            header-text-variant="light"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
            
            <template v-slot:modal-title>
                <div class="pb-2">Carga masiva de precios personalizados</div>
            </template>
            <b-row class="my-1 justify-content-md-center">
                <b-col sm="11">
                    <b-row >
                    <b-form-file
                    accept=".csv"
                    v-model="chosenFile"
                    :state="Boolean(chosenFile)"
                    placeholder="Elige un archivo o arrastralo aqui..."
                    drop-placeholder="Arrastra un archivo aqui..."
                    browse-text="Explorar"
                    @input="importCSV"
                    ></b-form-file>
                    </b-row>
                    <b-row class="pt-2" v-if="sendData">
                        <b-progress-bar :value="progress" :max="max" show-progress variant="success"></b-progress-bar>
                        
                    </b-row>
                    <b-row v-if="arrayErrors.length > 0" class="pt-2">
                        <b-col cols="12" md="12">
                        <b-alert show variant="danger" v-if="arrayErrors">
                            <ul class="alert alert-danger">
                            <li
                                v-for="(item, index) in arrayErrors"
                                :key="index"
                            >Item: {{ item.item}} Error: {{item.message}}</li>
                            </ul>
                        </b-alert>
                        </b-col>
                    </b-row>
                    <b-row v-if="finish">
                        <b-col cols="12" md="12" >
                            <b-alert show variant="success">Proceso Terminado.</b-alert>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <div>
                    <b-button variant="success" class="mr-2" @click.prevent="csvJSON"
                    :disabled="items.length < 1 || loading || deshabilitado">
                        Subir Archivo <b-icon icon="upload"></b-icon>
                        <b-spinner class="ml-1" label="Cargando..." small variant="dark" v-if="loading"></b-spinner>
                    </b-button>
                    <b-button variant="info" class="mr-2" :href="urlWebBackend+'download-precio-items-plantilla'" target="_blank">
                        Plantilla <b-icon icon="download"></b-icon>
                    </b-button>
                    <b-button variant="info" class="mr-2" @click.prevent="removeCsv" 
                    :disabled="chosenFile == null || loading">
                        Quitar <b-icon icon="trash"></b-icon>
                    </b-button>
                    <b-button variant="danger" @click.prevent="closeModal"
                    :disabled="loading"
                    >
                        Cerrar
                    </b-button>
                </div>
            </template>
        </b-modal>
    </b-container>
</template>
<script>
import { mapState} from 'vuex'
import conectar from "@/axios";
export default {
    computed: {
        ...mapState('configuration', ['urlWebBackend']),
    },
    props: {
        openModal: {
            type: Boolean
        }
    },
    data(){
        return{
            massiveUploadModal: false,
            sendData: false,
            alreadySend: false,
            progress: 100,
            max: 100,
            items: [],
            chosenFile: null,
            errors: {},
            arrayErrors: [],
            loading: false,
            deshabilitado: true,
            finish: false,
        }
    },
    methods:{
        closeModal(){
            this.$emit('close-modal');
            this.removeCsv();
        },
        async csvJSON() {
            this.sendData = true;
            this.loading = true;
            let vm = this;
            let activeRequests = [];
            let currentRequest = 0;
            this.deshabilitado = true;
            if ( this.alreadySend === false) {
                for(let [index, value] of this.items.entries()){
                    
                    if (index < 1) continue; // Salta la linea del header csv
                    let currentline = value.split(";");
                    if (currentline.length > 1) {
                        let data = {
                            item_data: currentline
                        };
                        let obj = {};
                        currentRequest = currentRequest + 1;            
                        let currentPromise = await conectar
                        .post("/precios-personalizados/store-items-massive", data)
                        .then(response => {
                            if (response.data.error === true) {
                                obj.message = response.data.errorMessage;
                                obj.item = response.data.item;
                                vm.arrayErrors.push(obj);
                            }
                            vm.progress = Math.ceil(
                                (index / (vm.items.length - 2)) * 100
                            );
                    
                        })
                        .catch(e => {
                            console.log(e);
                            vm.progress = Math.ceil(
                                (index / (vm.items.length - 2)) * 100
                            );
                            obj.item = currentline[0];
                            obj.message =
                                "Hubo un error en el servidor al tratar de registrar este item";
                            vm.arrayErrors.push(obj);
                        });

                        activeRequests.push(currentPromise);

                        if(currentRequest === 100){
                            await Promise.all(activeRequests)
                            currentRequest = 0;
                            await new Promise(resolve => setTimeout(resolve, 15000));
                        }
                    }

                }
                this.alreadySend = true;
                this.finish = true;
                this.loading = false;
                this.$emit("massive-import-send");
            }
        },
        removeCsv() {
            this.items = [];
            this.chosenFile = null;
            this.alreadySend = false;
            this.sendData = false;
            this.finish = false;
            this.loading = false;
            this.progress = 0;
            this.arrayErrors = [];
        },
        importCSV() {
            if (this.chosenFile !== null) {
                let reader = new FileReader();
                reader.readAsText(this.chosenFile);
                this.deshabilitado = false;
                reader.onload = () => {
                let datos = reader.result;
                this.items = datos.split("\n");
                };
            } else {
                this.chosenFile = null;
            }
        } 
    }
}
</script>